export default __webpack_public_path__ + "e13ffc455a97ea26419e8714753e3fb7.ico";